<!--Content chart-->
<div class="chart-content" *ngIf="type == 'chart'" [style]="containerStyle" [style.width]="'100%'"
  [style.height]="'100%'" #htmlContent>
  <div *ngIf="!isLoading()" class="chart-container">
    <ng-container *ngIf="showTitle && titlePosition == 'top'">
      <div class="block-label">
        @if (richTitle && showTitle) {
        <app-widget-title [title]="title" [design]="widget?.design?.title"></app-widget-title>
        } @else {
        <p [style]="titleStyle">{{ title }}</p>
        }
        <span class="error" *ngIf="error">{{ error }}</span>
      </div>
    </ng-container>

    <div class="chart">
      <canvas #chartCanvas style="width: 100%; height: 100%"></canvas>
    </div>

    <app-forecast-note [meta]="forecastMeta"></app-forecast-note>

    <ng-container *ngIf="showTitle && titlePosition != 'top'">
      @if (richTitle && showTitle) {
      <app-widget-title [title]="title" [design]="widget?.design?.title"></app-widget-title>
      } @else {
      <p class="block-label" [style]="titleStyle">{{ title }}</p>
      }
    </ng-container>
  </div>

  <app-widget-loading *ngIf="isLoading()" [graphType]="widget?.graphType"></app-widget-loading>

  <div id="chart-rendered" *ngIf="widgetRendered && !isLoading()"></div>
</div>